export const types = {
	SEARCH_REQUEST: 'singleKeywords/SEARCH_REQUEST',
	SEARCH_SUCCESS: 'singleKeywords/SEARCH_SUCCESS',
	SEARCH_FAILED: 'singleKeywords/SEARCH_FAILED',
	SEARCH_CLEAR: 'singleKeywords/SEARCH_CLEAR',
};

const initialState = {
	loading: false,
	data: [],
	error: null,
};

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {
		case types.SEARCH_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: [], // Clear data when search starts
			};

		case types.SEARCH_SUCCESS:
			return {
				...state,
				loading: false,
				data: Array.isArray(action.data) ? action.data : [], // Ensure data is an array
				error: null,
			};

		case types.SEARCH_FAILED:
			return {
				...state,
				loading: false,
				error: action.error,
				data: [], // Clear data when error occurs
			};
		case types.SEARCH_CLEAR:
			return {
				...state,
				loading: false,
				error: null,
				data: [],
			};


		default:
			return state;
	}
}

export const actions = {
	searchRequest: keyword => ({ type: types.SEARCH_REQUEST, keyword }),
	searchSuccess: data => ({ type: types.SEARCH_SUCCESS, data }),
	searchFailed: error => ({ type: types.SEARCH_FAILED, error }),
	clearData: () => ({ type: types.SEARCH_CLEAR }),

};
